import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, type DefaultValues, type FieldValues, type Mode } from "react-hook-form";
import type z from "zod";

export function useZodForm<T extends z.ZodType<FieldValues, FieldValues>>(
  schema: T,
  defaults?: DefaultValues<z.input<T>>,
  mode: Mode = "onTouched",
) {
  return useForm<z.input<T>, unknown, z.output<T>>({
    resolver: zodResolver(schema),
    defaultValues: defaults,
    mode,
  });
}
